import { bigPacks } from '@/mocks/homeData';

const band = [
  'from-primary-500/90 to-primary-700/90',
  'from-accent-600/90 to-accent-700/90',
  'from-secondary-500/90 to-secondary-700/90',
];

export default function BigPack() {
  return (
    <section id="bigpack" className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col items-start gap-5 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">礼包 · BIG PACK</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一键收藏 · 大礼包
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            整段打包的方向，目录先行、一键收藏入口。点击卡片看包内目录，收藏即可整段带走。
          </p>
        </div>
        <div className="inline-flex items-center gap-2 self-start rounded-md bg-background-100 px-3 py-1.5 text-xs text-foreground-600 md:self-auto">
          <i className="ri-checkbox-line text-accent-600"></i>
          共收录 148 条目 · 供方向参考
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
        {bigPacks.map((pack, idx) => (
          <div
            key={pack.key}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className={`relative flex h-28 items-end overflow-hidden bg-gradient-to-br ${band[idx % band.length]} p-5`}>
              <span className="pointer-events-none absolute right-4 top-3 font-heading text-xs font-bold uppercase tracking-[0.3em] text-background-50/70">
                {pack.key}
              </span>
              <div>
                <p className="text-xs font-semibold text-background-50/80">{pack.kind}</p>
                <h3 className="mt-1 font-heading text-lg font-bold leading-snug text-background-50">
                  {pack.name}
                </h3>
              </div>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <p className="text-sm leading-relaxed text-foreground-600">{pack.desc}</p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                  <i className="ri-stack-line text-foreground-400"></i>
                  {pack.items} 条目
                </span>
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                  <i className="ri-archive-line text-foreground-400"></i>
                  {pack.size}
                </span>
              </div>
              <a
                href="#guide"
                className="mt-5 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-4 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-bookmark-line"></i>
                收藏 · 看目录
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}